import { z } from "zod";
import { TaxResidenceSchema, UserSchema } from "../treezor/index.js";
import {
  isTreezorEffectiveBeneficiaryPepComplete,
  isTreezorEffectiveBeneficiarySharesComplete,
  treezorEffectiveBeneficiaryControllingPersonType,
  treezorEffectiveBeneficiaryPepFields,
  treezorEffectiveBeneficiarySharesPercent,
} from "./createTreezorEffectiveBeneficiary.js";

export default {
  params: z
    .object({
      accountId: z.string(),
      userId: z.number().int(),
      specifiedUSPerson: z.boolean(),
      title: UserSchema.shape.title,
      firstname: UserSchema.shape.firstname,
      lastname: UserSchema.shape.lastname,
      middleNames: UserSchema.shape.middleNames,
      birthday: z.union([z.iso.date(), z.literal("")]),
      placeOfBirth: UserSchema.shape.placeOfBirth,
      birthCountry: UserSchema.shape.birthCountry,
      nationality: UserSchema.shape.nationality,
      phone: UserSchema.shape.phone,
      address1: UserSchema.shape.address1,
      address2: UserSchema.shape.address2,
      address3: UserSchema.shape.address3.unwrap(),
      postcode: UserSchema.shape.postcode,
      city: UserSchema.shape.city,
      country: UserSchema.shape.country,
      controllingPersonType: treezorEffectiveBeneficiaryControllingPersonType,
      sharesPercent: treezorEffectiveBeneficiarySharesPercent.optional(),
      isLegalRepresentative: z.boolean(),
      taxResidence: z
        .object({
          country: TaxResidenceSchema.shape.country,
          taxPayerId: TaxResidenceSchema.shape.taxPayerId.unwrap().nullish(),
        })
        .nullish(),
      ...treezorEffectiveBeneficiaryPepFields,
    })
    .refine(isTreezorEffectiveBeneficiarySharesComplete, {
      path: ["sharesPercent"],
      message: "sharesPercent is required for shareholders",
    })
    .refine(isTreezorEffectiveBeneficiaryPepComplete, {
      path: ["isPep"],
      message:
        "occupationCategory, monthlyIncomeRange and personalAssetsRange are required for PEP",
    })
    .refine((data) => !data.specifiedUSPerson || data.taxResidence?.country === "US", {
      path: ["taxResidence", "country"],
      message: "US tax residence is required for specified US persons",
    })
    .refine(
      (data) =>
        !data.taxResidence || data.taxResidence.country === "FR" || !!data.taxResidence.taxPayerId,
      {
        path: ["taxResidence", "taxPayerId"],
        message: "taxPayerId is required when the tax residence country is not FR",
      },
    ),
  response: z.void(),
};
